<template>
    <div class="row font-20 font-medium justify-center mb-3">Thông tin hủy cấp thẻ</div>

    <DxValidationGroup ref="formValidation">
        <div class="row mt-4" v-if="ThongTinHuyCapThe.IdNhanVien">
            <div class="xs12">
                <DxSelectBox
                    label="Tên nhân viên (*)"
                    v-model="ThongTinHuyCapThe.IdNhanVien"
                    :dataSource="{
                        store: DanhSachNhanVien,
                        pageSize: 20,
                        paginate: true,
                    }"
                    display-expr="HoTen"
                    value-expr="IdNhanVien"
                    :search-enabled="true"
                    styling-mode="outlined"
                    no-data-text="Không có dữ liệu!"
                    :readOnly="true"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                    </DxValidator>
                </DxSelectBox>
            </div>
        </div>
        <div class="row mt-4" v-if="ThongTinHuyCapThe.IdThe">
            <div class="xs12">
                <DxSelectBox
                    label="Ký hiệu thẻ (*)"
                    v-model="ThongTinHuyCapThe.IdThe"
                    :dataSource="{
                        store: DanhSachTheKiemSoat,
                        pageSize: 20,
                        paginate: true,
                    }"
                    display-expr="KyHieuThe"
                    value-expr="IdThe"
                    :search-enabled="true"
                    styling-mode="outlined"
                    no-data-text="Không có dữ liệu!"
                    :readOnly="true"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                    </DxValidator>
                </DxSelectBox>
            </div>
        </div>
        <div class="row mt-4">
            <div class="xs12">
                <DxTextArea
                    label="Lý do hủy cấp thẻ (*)"
                    v-model="ThongTinHuyCapThe.LyDo"
                    :height="100"
                    :max-length="1000"
                    stylingMode="outlined"
                    validationMessageMode="always"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                    </DxValidator>
                </DxTextArea>
            </div>
        </div>
    </DxValidationGroup>

    <div class="row justify-space-between mt-4">
        <DxButton
            type="danger"
            text="Đóng"
            styling-mode="text"
            width="96px"
            @click="Dong"
        />
        <DxButton
            key="mdi-XACNHAN"
            type="default"
            text="Hủy cấp thẻ"
            styling-mode="contained"
            @click="HuyCapThe()"
        />
    </div>
</template>
<script>
import {
    DxTextArea,
    DxSelectBox,
    DxValidationGroup,
    DxButton,
    DxValidator,
} from "devextreme-vue";
import { DxRequiredRule, DxStringLengthRule } from "devextreme-vue/validator";
export default {
    components: {
        DxTextArea,
        DxSelectBox,
        DxValidationGroup,
        DxButton,
        DxValidator,
        DxRequiredRule,
        DxStringLengthRule,
    },
    data() {
        return {
            DanhSachNhanVien: [],
            DanhSachTheKiemSoat: [],
        };
    },
    computed: {
        ThongTinHuyCapThe: {
            get() {
                return this.$store.state.CapThe.ThongTinHuyCapThe;
            },
            set(data) {
                this.$store.commit("CapThe/Set", {
                    key: "ThongTinHuyCapThe",
                    data: data,
                });
            },
        },
    },
    methods: {
        Dong() {
            this.$emit("hiddenPopup", "PopupHuyCapTheChoNhanVien");
        },
        HuyCapThe() {
            let validate = this.$refs.formValidation.instance.validate();
            if (!validate.isValid) {
                return this.$Helper.Common.autoFocusError(validate);
            }
            this.ThucHienHuyCapThe();
        },
        async ThucHienHuyCapThe() {
            try {
                this.$startLoading;
                let rs;
                rs = await this.$store.dispatch("CapThe/HuyCapThe");
                if (rs.status) {
                    this.$Helper.ThongBaoToast("success", "Hủy cấp thẻ thành công!");
                    this.Dong();
                    this.$emit("getData");
                } else {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Hủy cấp thẻ thất bại!",
                        message: rs.message,
                    });
                }
            } catch (error) {
                console.log("🚀 ~ error:", error);
                this.$Helper.ThongBaoPopup({
                    message_title: "Hủy cấp thẻ thất bại!",
                    message: "Lỗi hệ thống client.",
                });
            } finally {
                this.$stopLoading;
            }
        },
        async LayDanhSachNhanVien() {
            try {
                this.DanhSachNhanVien = (
                    await this.$store.dispatch("NhanVien/LayDanhSachNhanVien")
                ).Store;
            } catch (error) {
                console.log("🚀 ~ error", error);
            }
        },
        async LayDanhSachTheKiemSoat() {
            try {
                this.DanhSachTheKiemSoat = (
                    await this.$store.dispatch("TheKiemSoat/LayDanhSachTheKiemSoat")
                ).Store;
            } catch (error) {
                console.log("🚀 ~ error", error);
            }
        },
    },
    created() {
        this.LayDanhSachNhanVien();
        this.LayDanhSachTheKiemSoat();
    },
    mounted() {},
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
